goog.provide('el8.ptdata.clinicalFormCollections');

goog.require('el8.model.base');
goog.require('el8.ptdata.clinicalForms');
goog.require('el8.util.base');


el8.ptdata.clinicalFormCollections = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);

    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);

        // FUTURE: make a model for observations if needed and set to the model
        // instead of raw object, if necessary
        if (spec.observations) {
          this.setObservations(spec.observations);
        }
        if (spec.total_score_observation) {
          this.setTotalScoreObservation(spec.total_score_observation);
        }
    };

    _class.addDateTime('createDate');
    _class.addProperty('observations');
    _class.addBoolean('confidential');
    _class.addIntProperty('clinicalFormId');
    _class.addStringProperty('collectionSummary');
    _class.addStringProperty('responseSummary');
    _class.addProperty('totalScoreObservation');

    _class.prototype.getClinicalForm = function getClinicalForm() {
      return el8.ptdata.clinicalForms.getById(this.getClinicalFormId());
    };

    _class.prototype.getNoteSummary = function getNoteSummary() {
      return this.getCollectionSummary();
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
    });

    /**
     * @returns {object[]} - an array containing the latest collection for each
     * clinical form that matches the specified history type ("history type" is the
     * type as understood by visit notes).
     */
    that.getCollectionsForHistoryType = function getCollectionsForHistoryType(historyType) {
      var latestCollectionsByFormId = {};
      that.all().forEach(function (collection) {
        var form = collection.getClinicalForm();
        if (form.getHistoryType() !== historyType) return;

        var existingCollectionForForm = latestCollectionsByFormId[form.getId()];
        if (
          !existingCollectionForForm ||
          collection.getCreateDate() > existingCollectionForForm.getCreateDate()
        ) {
          latestCollectionsByFormId[form.getId()] = collection;
        }
      });

      return Object.values(latestCollectionsByFormId);
    }

    return that;
})();
